function allowSidewaysScroll(element, splide) {
  const step           = splide.options.perMove || 1; // your “2”
  const distanceThresh = 30;  // total px you must accumulate
  const speedThresh    = 20;   // px delta per event to count as a flick
  const freezeMs       = 500; // cooldown after each movement

  let accX   = 0;
  let frozen = false;

  element.addEventListener('wheel', function(e) {
    // ignore ctrl+zoom and vertical scroll
    if (
      e.ctrlKey ||
      (Math.abs(e.deltaY) > Math.abs(e.deltaX) && !e.shiftKey)
    ) {
      return;
    }

    e.preventDefault();

    if (frozen) return;

    const dx = e.deltaX;

    // if this tick is too small, treat it as deceleration and reset
    if (Math.abs(dx) < speedThresh) {
      accX = 0;
      return;
    }

    // it’s a strong tick—accumulate
    accX += dx;

    // once you’ve scrolled far enough in one direction...
    if (Math.abs(accX) >= distanceThresh) {
      const dir = accX > 0 ? `+${step}` : `-${step}`;
      splide.go(dir);

      // reset & start cooldown
      accX   = 0;
      frozen = true;
      setTimeout(() => { frozen = false; }, freezeMs);
    }
  }, { passive: false });
}


// 2) Initialize sliders and hook up the helper
function initializeFeaturedCollectionSliders() {
  document.querySelectorAll('.collection-slider').forEach((container) => {
    if (container.classList.contains('splide-initialized')) return;
    container.classList.add('splide-initialized');

    const config = {
      perPage:   4.5,
      perMove:   2,
      gap:       '8px',
      pagination:false,
      speed:     700,
      padding:   { left: '3rem', right: '3rem' },
      easing:    'cubic-bezier(0.25,1,0.5,1)',
      arrows:    false,
      focus:     'left',
      trimSpace: true,
      wheel:     false,  // we handle wheel ourselves
      breakpoints: {
        1024: { perPage: 3, focus: 0 },
        768:  { perPage: 2, focus: 0, gap: '18px' },
        480:  { perPage: 1.2, focus: 0, gap: '20px', padding:{ left:16, right:16 }, perMove: 1, flickPower: 300, dragMinThreshold: { mouse: 4, touch: 14 } },
      },
    };

    // Mount Splide
    const splide = new Splide(container, config);
    splide.mount();

    // Wire up your existing arrow buttons
    const prev = container.querySelector('.custom-splide-arrow--prev');
    const next = container.querySelector('.custom-splide-arrow--next');
    if (prev) prev.addEventListener('click', () => splide.go('<'));
    if (next) next.addEventListener('click', () => splide.go('>'));

    // 3) Enable sideways scroll
    allowSidewaysScroll(container, splide);
  });
}

// 4) Boot it up
document.addEventListener('DOMContentLoaded', () => {
  window.MySplide.loadSplide(initializeFeaturedCollectionSliders);
});
document.addEventListener('shopify:section:load', initializeFeaturedCollectionSliders);